import { MultiSubmissionConfig } from '../types';

export const competition7MultiSubmissionConfig: MultiSubmissionConfig = {
  key: 'competition_7',
  title: 'Competition 7 Submission',
  description: 'Submit links and artifacts required for this specific competition.',
  submitLabel: 'Submit Competition 7 Package',
  fields: [
    {
      id: 'demo_link',
      type: 'url',
      label: 'Demo link',
      required: true,
      placeholder: 'https://demo.example.com',
    },
    {
      id: 'repository_link',
      type: 'url',
      label: 'Repository link',
      required: true,
      placeholder: 'https://github.com/org/repo',
    },
    {
      id: 'main_artifact',
      type: 'file',
      label: 'Main artifact',
      required: true,
      accept: '.zip,.csv,.pdf,.md,.txt',
    },
    {
      id: 'technical_notes',
      type: 'file',
      label: 'Technical notes (Markdown)',
      accept: '.md,text/markdown,text/plain',
    },
    {
      id: 'approach',
      type: 'select',
      label: 'Approach',
      required: true,
      options: [
        { value: 'baseline', label: 'Baseline' },
        { value: 'hybrid', label: 'Hybrid' },
        { value: 'custom', label: 'Custom' },
      ],
    },
    {
      id: 'fair_use_confirmed',
      type: 'checkbox',
      label: 'I confirm all submitted material follows competition rules.',
      required: true,
    },
  ],
};
